import { useState, useEffect } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/solid'
import Select from "react-select";
import { Country, City, State } from "country-state-city"

export default function CountryStateCityField(props) {
    const { label, input, meta, required = false } = props
    const countries = Country.getAllCountries();
    const [selectedCountry, setSelectedCountry] = useState(input.value.country)
    const [selectedState, setSelectedState] = useState(input.value.state)
    const [selectedCity, setSelectedCity] = useState(input.value.city)


    const updatedCountries = countries.map((country) => ({
        label: country.name,
        value: country.id,
        ...country
      }));

    function handleChange(value) {
        setSelectedCountry(value)
        setSelectedCity('')
        setSelectedState('')
        input.onChange({ country: value.name, state: '', city: ''})
    }

    function handleStateChange(value) {
        setSelectedState(value)
        setSelectedCity('')
        input.onChange({ country: selectedCountry.name, state: value.name, city: '' })
    }

    function handleCityChange(value) {
        setSelectedCity(value)
        input.onChange({ country: selectedCountry.name, state: selectedState.name, city: value.name })
    }
    
    useEffect(() => {
        if(input.value) {
            const selectedIndex = countries.findIndex((country) => country.name === input.value.country)
            if(selectedIndex >= 0) {
                setSelectedCountry(updatedCountries[selectedIndex])

                const states = State.getStatesOfCountry(updatedCountries[selectedIndex].isoCode).map((state) => ({ label: state.name, value: state.id, ...state }))
                const selectedStateIndex = states.findIndex((state) => state.name === input.value.state)
             
                if(selectedStateIndex >= 0) {
                    setSelectedState(states[selectedStateIndex])
                }

                const cities = City.getCitiesOfCountry(updatedCountries[selectedIndex].isoCode).map((city) => ({ label: city.name, value: city.id, ...city }))
                const selectedCityIndex = cities.findIndex((city) => city.name === input.value.city)
             
                if(selectedCityIndex >= 0) {
                    setSelectedCity(cities[selectedCityIndex])
                }
            }
        } else {
            const selectedIndex = countries.findIndex((country) => country.name === 'Saudi Arabia')
            if(selectedIndex >= 0) {
                setSelectedCountry(updatedCountries[selectedIndex])
                input.onChange({ country: updatedCountries[selectedIndex].name, state: selectedState ? selectedState.name : null, city: selectedCity ? selectedCity.name : null })
            }
        }
        
    }, [])

    const updatedStates = (countryId) => { 
        return State.getStatesOfCountry(countryId).map((state) => ({ label: state.name, value: state.id, ...state }));
    }

    const updatedCities = (countryId) => { 
        return City.getCitiesOfCountry(countryId).map((city) => ({ label: city.name, value: city.id, ...city }));
    }

    return (
        <div className="sm:col-span-6">
            <div className="mt-5 mb-2 border-t border-gray-200 pt-5">
                <h3 className="text-lg leading-6 font-medium text-gray-900">{label} {required && <span className="text-red-500">*</span>}</h3>
                <p className="mt-1 text-sm text-gray-500"></p>
            </div>
            <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div className="sm:col-span-2">
                    <label htmlFor={input.name} className="block text-sm font-medium text-gray-700">
                        Country
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                        <Select
                            label="country"
                            onChange={(value) => handleChange(value)}
                            options={updatedCountries}
                            value={selectedCountry}
                        />
                        {meta.error && meta.touched && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>}
                    </div>
                    {meta.error && meta.touched && <p className="mt-2 text-sm text-red-600">{meta.error}</p>}
                </div>
                <div className="sm:col-span-2">
                    <label htmlFor={input.name} className="block text-sm font-medium text-gray-700">
                        State
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                        <Select
                            label="state"
                            onChange={(value) => handleStateChange(value)}
                            options={updatedStates(selectedCountry ? selectedCountry.isoCode : null)}
                            value={selectedState}
                        />
                        {meta.error && meta.touched && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>}
                    </div>
                    {meta.error && meta.touched && <p className="mt-2 text-sm text-red-600">{meta.error}</p>}
                </div>
                <div className="sm:col-span-2">
                    <label htmlFor={input.name} className="block text-sm font-medium text-gray-700">
                        City
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                        <Select
                            label="city"
                            onChange={(value) => handleCityChange(value)}
                            options={updatedCities(selectedCountry ? selectedCountry.isoCode : null)}
                            value={selectedCity}
                        />
                        {meta.error && meta.touched && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>}
                    </div>
                    {meta.error && meta.touched && <p className="mt-2 text-sm text-red-600">{meta.error}</p>}
                </div>
            </div>
        </div>
    )
}